import { instance, objectToParams } from './api';

export const getDeliveries = (args) => instance.get(`/api/v1/deliveries?${objectToParams(args)}`);

export const getDeliveryById = (id) => instance.get(`/api/v1/deliveries/${id}`);

export const putDeliveryDeposit = (id, depositId) => instance.put(`/api/v1/deliveries/${id}/deposit/${depositId}`, {});

export const getDeliveryStockById = (id, args) =>
  instance.get(`/api/v1/deliveries/${id}/stock?${objectToParams(args)}`);

export const postDeliveryStockById = (id, payload) => instance.post(`/api/v1/deliveries/${id}/stock`, payload);

export const postDeliveryAllStockById = (id) => instance.post(`/api/v1/deliveries/${id}/stock/all`, {});

export const postDeliveryStatus = (id, state) => instance.post(`/api/v1/deliveries/${id}/${state}`, {});
